import { isNotNil } from '@flowio/is';
/**
 * Returns the top-level document object for the specified node.
 */

export default function getOwnerDocument(node) {
  return isNotNil(node) && node.ownerDocument || document;
}
//# sourceMappingURL=getOwnerDocument.js.map